<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="A" :itemcode="pagecode"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">{{userdata.zsdn_version == 2 ? '企业' : '按融资阶段找企业'}}</span>
						<p class="fl titlefont"  v-show="userdata.zsdn_version == 1 && searchtype == 2">招新引优，一个非常重要的群体是获得融资的科技企业，这里汇集了全国所有获投企业。<br>怎么选呢？种子轮和天使轮看团队、看技术，A轮看产品，B轮看市场和商业模式，C轮看竞争格局。</p>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">全部内资企业库</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext" @keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>
					<div class="opport-screen-list1">
						<!-- <div class="spage-searchbox "> -->
							<dl class="opport-screen bdbe" v-show="userdata.zsdn_version == 2 && enterpriseType!=0 &curWebsite.type != 5">
							<dt class="fl">企业库</dt>
							<dd class="fl" >
								<span :key="index" v-for="(item,index) in enterpriseTypeList"
									@click="routerself(item.url)"
									:class="enterpriseType == item.id?'a-screen current':'a-screen'">{{item.name}}</span>
								<span @click="routerself('/totalEnterprises')" class="a-screen">全部内资企业库</span>
								<span class="blueline"></span>
								<span @click="routerself('/foreignEnterprises')" class="a-screen">境外上市企业库</span>
								<span @click="routerself('/forcapEnterprise')" class="a-screen">外资企业库</span>
								<!-- 2024.4.29暂时隐藏 -->
								<!-- <el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
										class="el-icon-question listeltootipicon"></i>
									<div slot="content" class="list_tips">
										<p>上市公司：A股上市的公司 </p>
										<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p>
										<p>外商投资企业：外商投资的企业</p>
										<p>境外上市企业：在境外证券交易所公开上市的企业</p>
									</div>
								</el-tooltip> -->
								<video-teaching :type="1"></video-teaching>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="userdata.zsdn_version == 2 && enterinarr.length>0">
							<dt class="fl">企业类型</dt>
							<dd class="fl" v-if="curWebsite.type != 5">
								<span :key="index" v-for="(item,index) in enterinarr"
									@click="routerself('/enterpriseList?type='+item.type+'&Pt='+item.ptId);"
									:class="searchtype == item.type?'a-screen current':'a-screen'">{{item.name}}</span>
								<video-teaching :type="1"></video-teaching>
							</dd>
							<dd class="fl" v-if="curWebsite.type == 5"> 
								<span :key="index" v-for="(item,index) in tz_enterinarr"
									@click="routerself('/enterpriseList?type='+item.type);"
									:class="searchtype == item.type?'a-screen current':'a-screen'">{{item.name}}</span>
								<!-- <span @click="routerself('/totalEnterprises')" class="a-screen">全部内资企业</span> -->
								<el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
										class="el-icon-question listeltootipicon"></i>
									<div slot="content" class="list_tips">
										<p>创新企业：被专业投资机构认可并成功融资的企业</p>
										<p>优质企业：具有市场竞争优势和持续发展潜力的企业</p>
									</div>
								</el-tooltip> 
							</dd>
						</dl>
						<!-- 非上市龙头企业 -->
						<dl class="opport-screen bdbe" v-show="searchtype==1  && qysltagUnique.length>0">
							<dt class="fl">企业实力</dt>
							<dd class="fl ">
								<div class="fl" :key="index" v-for="(item,index) in qysltagUnique">
									<span @click="qyslClick(item.tagCode,'qysl')"
										:class="searchtagdata[0] == item.tagCode ?'a-screen current' : 'a-screen'"
										:style="index>0 && index<9?fontb:''">{{item.tagName}}</span>
									<el-tooltip class="item smartTip-text fl" effect="light" placement="top-start"
										v-if="index == 5"><i class="el-icon-question listeltootipicon"
											style="left:-6px;"></i>
										<div slot="content" class="list_tips">
											<p>世界500强、中国500强、中国民营企业500强、中国制造业民营企业500强分属于上市公司和龙头企业两个企业库。</p>
										</div>
									</el-tooltip>
								</div>
							</dd>
						</dl>
						<!-- 上市公司企业实力 -->
						<dl class="opport-screen bdbe" v-show=" searchtype==9 && qysltagUnique.length>0">
							<dt class="fl">企业实力</dt>
							<dd class="fl ">
								<div class="fl" :key="index" v-for="(item,index) in qysltagUnique">
									<span @click="qyslClick(item.tagCode,'qysl')"
										:class="searchtagdata[0] == item.tagCode ?'a-screen current' : 'a-screen'"
										:style="index>0 && index<8?fontb:''">{{item.tagName}}</span>
									<el-tooltip class="item smartTip-text fl" effect="light" placement="top-start"
										v-if="index == 5"><i class="el-icon-question listeltootipicon"
											style="left:-6px;"></i>
										<div slot="content" class="list_tips">
											<p>世界500强、中国500强、中国民营企业500强、中国制造业民营企业500强分属于上市公司和龙头企业两个企业库。</p>
										</div>
									</el-tooltip>
								</div>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-if="searchtype == 2">
							<dt class="fl">融资轮次</dt>
							<dd class="fl ">
								<div class="fl" :key="index" v-for="(item,index) in rongzilunciData">
									<span @click="qyslClick(item.tagCode,'investRound')"
										:class="investRound == item.tagCode ?'a-screen current' : 'a-screen'"
										:style="index>0 && index<8?fontb:''">{{item.tagName}} </span>
								</div>
							</dd>
						</dl>
						<!-- 优质企业实力 -->
						<dl class="opport-screen bdbe" v-show="searchtype==3 && qysltagUnique.length>0">
							<dt class="fl">企业实力</dt>
							<dd class="fl ">
								<div class="fl" :key="index" v-for="(item,index) in qysltagUnique">
									<span @click="qyslClick(item.tagCode,'qysl')"
										:class="searchtagdata[0] == item.tagCode ?'a-screen current' : 'a-screen'"
										:style="index>0 && index<3?fontb:''">{{item.tagName}}</span>
								</div>
							</dd>
						</dl>
						<!-- 省市区筛选 -->
						<cityScreen @getEnterpriseList="cityScreenFun" :isShowTips='true' :showTipsType="showTipsType"></cityScreen> 
						<!-- 上市公司  拿地信息 技术实力 股权投资信息  项目投资信息 企业上市标签 财力稳健  研发投入  -->
						<!-- 龙头企业  拿地信息 技术实力 股权投资信息  项目投资信息   -->
						<!-- 创新企业标签  拿地信息 技术实力 股权投资信息 融资时间 融资金额 投资机构-->
						<!-- 优质企业标签  拿地信息 技术实力 股权投资信息 上市公司供应链-->
						<dl class="opport-screen bdbe" v-show="searchtype > 0 && initialTagdata.length>0 && userdata.zsdn_version == 2">
							<dt class="fl">画像标签</dt>
							<dd class="fl">
								<div class="selecttag" :key="index" v-for="(list,index) in initialTagdata">
									<select :name="list.tagCode" @change="choosetaglist($event,index)"
										class="enterlist_select">
										<option value="empty">{{list.tagName}}</option>
										<option :value="item.tagCode" :key="d" v-for="(item,d) in list.children"
											v-if="item.tagName!='上市公司' && item.tagName !='先进院客户'">{{item.tagName}}
										</option>
									</select>
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"
										v-if="list.tagName=='拿地信息'">
										<i class="el-icon-question listeltootipicon listeltootipicon1"></i>
										<div slot="content" class="list_tips">
											拿地面积大：拿地面积在100亩及以上的企业 <br />
											拿地数量多：拿地次数在三次及以上的企业 <br />
											有拿地：拿地面积在10亩及以上的企业 <br />
											近期有拿地：一年内有拿地信息的企业 <br />
											连续拿地：两年内拿地次数有两次及以上的企业 <br />
										</div>
									</el-tooltip>
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"
										v-if="list.tagName=='专利证书'||list.tagName=='技术实力'"><i
											class="el-icon-question listeltootipicon1"></i>
										<div slot="content" class="list_tips">
											专利多：专利信息有50条及以上的企业 <br />
											有专利：专利信息少于50条的企业 <br />
											证书多：拥有证书10种及以上的企业 <br />
											有证书：拥有证书少于10种的企业 <br />
											专利质量高：发明专利占比多的企业 <br />
										</div>
									</el-tooltip>
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"
										v-if="list.tagName=='股权投资信息'">
										<i class="el-icon-question listeltootipicon1"></i>
										<div slot="content" class="list_tips">
											股权投资数量多：对外投资数10次及以上的企业 <br />
											近期有股权投资：一年内有对外投资信息的企业 <br />
											有股权投资：有股权投资信息的企业 <br />
											连续股权投资:两年内股权投资次数2次及以上的企业 <br />
										</div>
									</el-tooltip>

									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"
										v-if="list.tagName=='财力稳健'">
										<i class="el-icon-question listeltootipicon1"></i>
										<div slot="content" class="list_tips">
											盈利能力强：企业销售净利率大于15% <br />
											偿债能力强：企业流动比率大于2 <br />
											成长能力强：企业净利润同比增长大于20% <br />
											现金流稳健：企业期末现金及现金等价物余额大于0 <br />
										</div>
									</el-tooltip>
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"
										v-if="list.tagName=='项目投资信息'">
										<i class="el-icon-question listeltootipicon1"></i>
										<div slot="content" class="list_tips">
											项目投资数量多:对外投资数10次及以上的上市公司 <br />
											连续项目投资:两年内投资项目次数有2次及以上的上市公司 <br />
											近期有项目投资：一年内投资项目次数有1次及以上的上市公司 <br />
											有项目投资：有投资项目的上市公司 <br />
										</div>
									</el-tooltip>
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"
										v-if="list.tagName=='研发投入'">
										<i class="el-icon-question listeltootipicon1"></i>
										<div slot="content" class="list_tips">
											研发人员多：企业研发人员1000人及以上或者研发人员占比超过20% <br />
											研发投入多：企业研发支出占营业额15%以上或研发支出金额1亿及以上<br />
											研发能力强：企业研发投入占比多及专利质量高 <br />
										</div>
									</el-tooltip>
								</div>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="userdata.zsdn_version == 2 ">
							<dt class="fl">科技实力</dt>
							<dd class="fl">
								<div class="selecttag" :key="index" v-for="(list,index) in qyslitagPublicselect">
									<select :name="list.tagCode" @change="choosetaglist1($event,index)">
										<option value="empty">{{list.tagName}}</option>
										<option :value="item.tagCode" :key="d" v-for="(item,d) in list.children">
											{{item.tagName}}
										</option>
									</select>
								</div>
							</dd>
						</dl>
						<notionScreen :type="1" :isShowFutureIndustries="true" :isIntegration="true" :notionNumList='[]' :showNotionCodeList="{}" :showNotionExtend="true" :token="userdata.token" @chooseNotion="chooseNotion" :isShowNotionScreen="true"></notionScreen>
					</div>
				</div>
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span
								class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'"
							@click="enlistExport()" v-if="userdata.groupType == 1"
							v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
						</div>
					</div>
					<!-- 多维度分数筛选 -->
					<ul class="dimensionScreen oh w95mg" v-show="enterpristlist.length>0">
						<li :class="orderField == list.type ?'fl current ':'fl '" :key="index"
							v-for="(list,index) in dimensionList" @click="tablesort(list.type);"
							v-show="list.sts.indexOf(searchtype)>-1">
							<span
								:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}
							</span>
							<span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
						</li>
					</ul>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<!-- 龙头企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-if="searchtype == 1 || searchtype == 9 || searchtype == 3 || searchtype == 0">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr>
							<tr :key="index" v-for="(list,index) in enterpristlist">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,searchtype)">
									{{list.title}}
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="i1" v-for="(item,i1) in list.notionlist"
										@click="tagrouter('/enterpriseTag',searchtype,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" :key="i1" v-for="(item,i1) in list.taglist"
										@click="tagrouter('/enterpriseTag',searchtype,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td class="collectfont1"><span
										@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
								</td>
							</tr>
						</table>
						<!-- 创新企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype == 2">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>地区</th>
								<th>投资方</th>
								<th>编辑</th>
							</tr>
							<tr :key="index" v-for="(list,index) in enterpristlist">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title"
									@click="routerlinkid('/enterprises',list.stockCode,searchtype,'',searchtype)">
									{{list.title}}
								</td>
								<td class="conpanytags hastag1" v-show="list.notion!=''">
									<span class="span-tag" :key="i1" v-for="(item,i1) in list.notionlist"
										@click="tagrouter('/enterpriseTag',searchtype,'notion',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td class="conpanytags hastag1" v-show="list.tag!=''">
									<span class="span-tag" :key="i1" v-for="(item,i1) in list.taglist"
										@click="tagrouter('/enterpriseTag',searchtype,'tag',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td>{{list.financingRound[0].rount}}</td>
								<td>{{list.financingRound[0].time}}</td>
								<td>{{list.financingRound[0].amount}}</td>
								<td>{{list.area}}</td>
								<td class="orglist ">
									<p v-if="list.financingRound[0].id!='none'">
										<span :key="inds" v-for="(org,inds) in list.financingRound[0].orgList"
											data="org.id" :class="org.id!=0?'curp':''"
											@click="routerlinkid('investement-enterprises',org.id)">{{org.orgName}}<i
												v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span>
									</p>
									<p v-if="list.financingRound[0].id=='none'">-</p>
								</td>
								<td class="collectfont1"><span
										@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
								</td>
							</tr>
						</table>
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype == 'A090206' || searchtype == 'A090208'">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td>{{(page-1)*pageSize+i+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">
									{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td class="collectfont1"><span
										@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
								</td>
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出列表弹框 -->
		<div class="enlistexportPop" v-show="exportpop">
			<div class="enlistexportPop_box">
				<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
				<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
				<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b
						class="redfont">{{exportnum}}</b>次</p>
				<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
				<span class="closebtn" @click="exportpop=false"></span>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script> 
	import {financing_rounds } from '@/utils/enterprise-tag.js'
	import { mapState, mapMutations, mapGetters } from "vuex";
	import {totalqysl} from '@/utils/enterprise-tag.js'

	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite:this.$api.getWebsiteType(),
				title: "上市公司",
				pagecode: 'A-SSGS', 
				hxtagname: "",
				enterpriseTypeList: [{name: "龙头企业库", id: 1,url:'/enterpriseList?type=9&Pt=1',
				children:[{
						ptId:1,
						pagecode: 'A-LTQY',
						type: 9,
						name: "A股上市龙头企业", //原上市企业
						tagnum: 10010,
						hxtagname: '&企业上市标签&拿地信息&股权投资信息&财力稳健&项目投资信息'
					},
					{
						ptId:1,
						pagecode: 'A-GGZZ',
						type: 'A090206',
						name: "港股中资企业",//
						tagnum: 10010,
						hxtagname: ''
					},
					{
						ptId:1,
						pagecode: 'A-MGZZ',
						type: 'A090208',
						name: "美股中资企业",//
						tagnum: 10010,
						hxtagname: ''
					},
					{
						ptId:1,
						pagecode: 'A-LTQY',
						type: 1,
						name: "非上市龙头企业",//原龙头企业
						tagnum: 10010,
						hxtagname: '&项目投资信息&拿地信息&股权投资信息&'
					},
					
				]},
				{name: "科创企业库", id: 2,url:'/enterpriseList?type=2&Pt=2',
				children:[{
						ptId:2,
						pagecode: 'A-KCQY',
						type: 2,
						name: "创投企业",
						tagnum: 3,
						hxtagname: '&拿地信息&股权投资信息&财力稳健&项目投资信息&融资时间标签&融资金额标签&'
					},
					{
						ptId:2,
						pagecode: 'A-KCQY',
						type: 3,
						name: "优质企业",
						tagnum: 10009,
						hxtagname: '&拿地信息&股权投资信息&'
					},
				]}
				
			],
				enterinarr: [{
						ptId:1,
						pagecode: 'A-LTQY',
						type: 9,
						name: "A股上市龙头企业", //原上市企业
						tagnum: 10010,
						hxtagname: '&企业上市标签&拿地信息&股权投资信息&财力稳健&项目投资信息'
					},
					{
						ptId:1,
						pagecode: 'A-GGZZ',
						type: 'A090206',
						name: "港股中资企业",//
						tagnum: 10010,
						hxtagname: ''
					},
					{
						ptId:1,
						pagecode: 'A-MGZZ',
						type: 'A090208',
						name: "美股中资企业",//
						tagnum: 10010,
						hxtagname: ''
					},
					{
						ptId:1,
						pagecode: 'A-LTQY',
						type: 1,
						name: "非上市龙头企业",//原龙头企业
						tagnum: 10010,
						hxtagname: '&项目投资信息&拿地信息&股权投资信息&'
					},
					{
						ptId:2,
						pagecode: 'A-CXQY',
						type: 2,
						name: "创投企业",
						tagnum: 3,
						hxtagname: '&拿地信息&股权投资信息&财力稳健&项目投资信息&融资时间标签&融资金额标签&'
					},
					{
						ptId:2,
						pagecode: 'A-YZQY',
						type: 3,
						name: "优质企业",
						tagnum: 10009,
						hxtagname: '&拿地信息&股权投资信息&'
					},
				],
				tz_enterinarr: [{
						pagecode: 'A-CXQY',
						type: 2,
						name: "创新企业",
						tagnum: 3,
						hxtagname: '&拿地信息&股权投资信息&财力稳健&项目投资信息&融资时间标签&融资金额标签&'
					},
					{
						pagecode: 'A-YZQY',
						type: 3,
						name: "优质企业",
						tagnum: 10009,
						hxtagname: '&拿地信息&股权投资信息&'
					},
				],
				investRound: "",
				rongzilunciData: [],//由js函数调取
				islogin: false,
				userdata: {
					currentCity: {
						text: ""
					},
					zsdn_version:2,
					username:'',
					remainDays:'',
					endDate:'',
					operatList: {
						mkczsm: false
					},
					token: null
				},
				fontb: {
					fontWeight: 'bold'
				},
				showscreen: true,
				notiontext: '',
				notionCode: 0,
				chooseNotionlist: [0, 0, 0, 0, 0],
				searchtype: 0,
				searchTagnum: 10010,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [{
						name: '综合',
						type: 0,
						sts: '9132 A090208 A090206',
					}, {
						name: '融资时间',
						type: 1,
						sts: '002',
					}, {
						name: '企业实力',
						type: 2,
						sts: '9132',
					}, {
						name: '投资力度',
						type: 3,
						sts: '9132',
					},
					{
						name: '本省关联度',
						type: 4,
						sts: '9132',
					}, {
						name: '拿地数量',
						type: 5,
						sts: '9132 A090208 A090206',
					}, {
						name: '拿地面积',
						type: 6,
						sts: '9132 A090208 A090206',
					}, {
						name: '拿地金额',
						type: 7,
						sts: '9132 A090208 A090206',
					},
					{
						name: '投资项目数量',
						type: 8,
						sts: '9132 A090208 A090206',
					}, {
						name: '投资项目金额',
						type: 9,
						sts: '9132 A090208 A090206',
					}, {
						name: '控制企业',
						type: 10,
						sts: '913 A090208 A090206',
					},
				],
				flag: false,
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				initialTagdata: [{
					tagName: "",
					tagCode: "",
					children: []
				}],
				qyslitagCom: [], //公共科技实力
				qyslitagPublicselect: [], //公共科技实力下拉框版
				comSearchdata: ['empty', 'empty', 'empty'], //公共科技实力下拉框版 存储值
				qysltagUnique: [], //独有企业实力
				searchtagdata: ['0'],
				enterpristlist: [],
				usertaglist: [],
				num: 0,
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序   
				commontagcode: 0,
				tyinitialTagdata: [],
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',
				enterpriseType: 0, //企业类型
				showTipsType: 3,
				isShowFreeUserTips: false,
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},
		//监听路由变化、newVal：目标路由，oldVal:原路由，路由不同时重新请求数据
		watch: {
			$route: function(newVal, oldVal) {
				console.log('watch');
				// console.log(this.$route.query.type);
				var ddst = 0;
				if (this.$route.query.type) {
					ddst = this.$route.query.type;
				}
				if(this.$route.query.Pt){
					this.enterpriseType = this.$route.query.Pt;
					if(this.enterpriseType == 1){
						this.showTipsType = 3;
					}else if(this.enterpriseType == 2){
						this.showTipsType = 4; 
					}
				}
				this.searchtype = ddst;
				this.enterpriseTypeList.forEach(item => {
					if (item.id == this.$route.query.Pt) {
						this.chooseEnterPriseType(item);
					}
				})
				var defaultlist = this.enterinarr.filter(list => {
					return list.type == ddst;
				});
				this.typetoggle(defaultlist[0]);
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.bus.$emit('loading', true);
			this.userdata = this.getuseriformation() || this.userdata;
			this.rongzilunciData=financing_rounds();
			// _this.notionlist=NotionTree;  
			var pagetype = this.$route.query.type;
			if (pagetype) {
				this.searchtype = pagetype;
			};
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			var defaultlist = {},
				_this = this;
			this.enterpriseTypeList.forEach(item => {
				if (item.id == this.$route.query.Pt) {
					this.chooseEnterPriseType(item);
				}
			})
			defaultlist = this.enterinarr.filter(list => {
				return list.type == _this.searchtype;
			})
			this.typetoggle(defaultlist[0]);
		},
		methods: {
			qyslClick(tagCode,type){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if(type == 'qysl'){
					this.searchtagdata[0]= tagCode;
				}else if(type == 'investRound'){
					this.investRound= tagCode;

				}
				this.ajaxsearchcompany()
			},
			chooseEnterPriseType(item){
				console.log('tem',item);
				this.enterpriseType = item.id;
				this.enterinarr = item.children;
			},
			//概念单选 层级显示
			chooseNotion(chooseNotionlist,notionCode){
				// this.chooseNotionlist=chooseNotionlist;
				console.log('父组件code',notionCode);
				this.notionCode=notionCode; 
				this.ajaxsearchcompany(1);
			},
			//企业列表切换
			typetoggle(lists) {
				// console.log('是否执行')
				// console.log('企业列表切换',this.searchtyp != list.type);
				if (this.searchtyp != lists.type) {
					this.searchtype = lists.type;
					this.pagecode = lists.pagecode;
					this.title = lists.name;
					// document.title = '产业招商大脑-' + list.name; 
					this.hxtagname = lists.hxtagname;
					this.getCommonTaglist(2, lists.tagnum);
					// this.ajaxsearchcompany();
				}
				 
			},
			//获取请求连接url
			getajaxUrl(apiurl, searchtype) {
				if (searchtype != 'search') {
					this.searchtext = "";
				}
				var _this = this,
					ajaxurl = '';
				//公司列表 type:1/2 area:provinceid industry行业id capital 注册资本 （暂无） 标签（暂无） chain相关产业链（暂无） page页码
				var searchtagdata1 = this.searchtagdata.filter(item => {
					return item != 'empty' && item != 0;
				});
				this.comSearchdata.forEach(item => {
					if (item != 'empty' && item != 0) {
						searchtagdata1.push(item);
					}
				})
				var tagaja = '';
				if (this.searchtype == 'A090206' || this.searchtype == 'A090208') { //港美股中资企业专用
					searchtagdata1.push(this.searchtype);
				}
				if (searchtagdata1.length > 0) {
					tagaja = _this.datajoin('tag', searchtagdata1);
				}
				var notionja = this.splicing('notion', this.notionCode);
				var kwaja = this.splicing('kw', this.searchtext);
				var countyidja = this.splicing('county', this.countyid);
				var provinceidja = this.splicing('province', this.provinceid);
				var cityidja = this.splicing('city', this.cityid);
				ajaxurl = apiurl + '?type=' + this.searchtype + '&search=1' + tagaja + "&orderField=" + this.orderField +
					"&orderType=" + this.orderType + notionja + kwaja + countyidja + provinceidja + cityidja;
				if (this.searchtype == 2) {
					ajaxurl = ajaxurl + this.splicing('investRound', this.investRound);
				}
				if (this.searchtype == 'A090206' || this.searchtype == 'A090208') { //港美股中资企业专用 type=0
					ajaxurl = apiurl + '?type=0' + '&search=1' + tagaja + "&orderField=" + this
					.orderField + "&orderType=" + this.orderType + notionja + kwaja + countyidja + provinceidja + cityidja;
				}
				return ajaxurl;
			},
			//企业列表导出数据
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				}
				// console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
				// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export()) + '&token=' + this.userdata.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					// console.log('一分钟冷却计时')
				}, 60000)
			},
			//时间/分数升降序
			tablesort(field) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				console.log('排序', field, this.orderType)
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.ajaxsearchcompany();
			},
			//搜索关键词 
			searchkwfun() {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					this.searchtext='';
					return;
				}
				this.searchtext = $.trim(this.searchtext);
				if (this.searchtext.length > 0) {
					var pathque = {
						kw: this.searchtext
					};
					this.routerlinkarry('/totalSearch', pathque);
				} else {
					this.$message({
						type: 'error',
						message: '请输入关键词搜索',
					});
				}
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			//画像标签高级搜索
			getCommonTaglist(type, tagnum) {
				var _this = this;
				this.$axios.get(this.$api.tag.tag.list() + '?categoryId=' + type, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('commontaglist', res.data);
					var tagdsta = res.data.list.filter(data => {
						return data.children.length > 0;
					})
					// for (var i = 0; i < tagdsta.length; i++) {
					// 	_this.searchtagdata.push('empty');
					// }
					//企业通用标签 
					var datalen = tagdsta.length;
					_this.qyslitagCom = tagdsta[datalen - 1].children; //科技实力
					var selectddd = [
						//{tagName:"中国专利奖",tagCode:"A021515"}2,{tagName:"认定企业技术中心",tagCode:"A021511"}3,
						{
							tagName: "科技专项",
							tagCode: 'empty',
							children: [{
								tagName: "国家科技重大专项",
								tagCode: "A021502"
							}, {
								tagName: "国家薪火项目",
								tagCode: "A021504"
							}, {
								tagName: "国家重大科学仪器设备开发专项",
								tagCode: "A021507"
							}]
						},
						{
							tagName: "科技奖项",
							tagCode: 'empty',
							children: [{
								tagName: "国家标准起草单位",
								tagCode: "A021503"
							}, {
								tagName: "国家级科学技术进步奖",
								tagCode: "A021505"
							}, {
								tagName: "创新积分500强",
								tagCode: "A021517"
							}]
						},
						{
							tagName: '研发中心',
							tagCode: 'empty',
							children: [{
								tagName: "国家地方联合工程研究中心",
								tagCode: "A021506"
							}, {
								tagName: "国家级工业设计中心",
								tagCode: "A021508"
							}, {
								tagName: "高新技术企业研发中心",
								tagCode: "A021509"
							}, {
								tagName: "企业国家重点实验室",
								tagCode: "A021510"
							}, {
								tagName: "院士专家工作站",
								tagCode: "A021512"
							}, {
								tagName: "博士后工作站",
								tagCode: "A021513"
							}, {
								tagName: "博士后流动站",
								tagCode: "A021514"
							}, {
								tagName: "国家技术创新示范企业",
								tagCode: "A021516"
							}]
						},
						{
							tagName: '名企背景',
							tagCode: 'empty',
							children: [{
								tagName: "华为系",
								tagCode: "A021701"
							}, {
								tagName: "字节系",
								tagCode: "A021702"
							}, {
								tagName: "腾讯系",
								tagCode: "A021703"
							}, {
								tagName: "阿里系",
								tagCode: "A021704"
							}, {
								tagName: "百度系",
								tagCode: "A021705"
							}, {
								tagName: "京东系",
								tagCode: "A021706"
							}, {
								tagName: "美团系",
								tagCode: "A021707"
							}, {
								tagName: "小米系",
								tagCode: "A021708"
							}, ]
						}

					]
					_this.qyslitagPublicselect = selectddd;
					_this.qyslitagCom.unshift({
						tagName: "全部",
						tagCode: "0"
					}); //没有用到了
					_this.tyinitialTagdata = tagdsta; //通用画像标签储存;
					// console.log('通用画像标签储存',_this.tyinitialTagdata)
					_this.getocnapidoctaglist(tagnum);
				});
			},
			//获取后台标签列表
			getocnapidoctaglist(type) {
				var _this = this,
					conHuaXiangTag = [],
					comdelateText = '',
					uniqueHuaxiangdata = [],
					qysltagUniqueData = [],
					comdelateText2 = '',
					qysltagShift = [],
					searchdataempty = ['0'];
				// console.log(type)
				if (type < 1) {
					return;;
				}
				this.$axios.get(this.$api.tag.tag.list() + '?categoryId=' + type, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('gettagno', res.data);
					var tagdsta = res.data.list.filter(data => {
						return data.children.length > 0;
					})
					/*
					<!-- 上市公司  拿地信息 技术实力 股权投资信息  项目投资信息 企业上市标签 财力稳健  研发投入  -->
					<!-- 龙头企业  拿地信息 技术实力 股权投资信息  项目投资信息   -->
					<!-- 创新企业标签  拿地信息 技术实力 股权投资信息 融资时间 融资金额 投资机构-->
					<!-- 优质企业标签  拿地信息 技术实力 股权投资信息 上市公司供应链--> 
					*/
					if (type == 3) { //创新企业专属标签 
						comdelateText = '&企业类型标签&企业规模标签&上市公司供应链&行业概念标签&其他个性化标签&行业潜力标签&技术实力标签&区域特色标签&';
						//独有画像标签
						uniqueHuaxiangdata = tagdsta.filter(item => {
							return item.tagName != '其他个性化标签' && item.tagName != '融资轮次标签';
						})
						//特有企业实力 
						comdelateText2 = '&尚未获投&Pre-IPO&基石轮&已上市&新三板&已退市&战略投资&不明确&已被收购&已合并';
						qysltagShift = [{
							tagName: "全部",
							tagCode: "0"
						}];
					} else if (type == 10010) { //龙头企业c和上市企业专属标签 
						var ndata1 = [],
							comdelateText = "&企业类型标签&企业规模标签&行业概念标签&其他个性化标签&行业潜力标签&上市公司供应链&区域特色标签&技术实力标签&";
						//特有画像标签
						let leadDelateText = '&经营状况&企业实力标签&';
						if (_this.searchtype == 1) {
							leadDelateText = leadDelateText + '&财力稳健&研发投入&企业上市标签&';
						}
						ndata1 = tagdsta.filter(item => {
							return leadDelateText.indexOf(item.tagName) < 1;
						})
						conHuaXiangTag.unshift(ndata1[0]);
						// _this.initialTagdata = ndata;
						ndata1.splice(0, 1);
						uniqueHuaxiangdata = ndata1;
						//特有企业实力 龙头和上市还是有细微差距 分开算吧
						comdelateText2 =
							'&世界500强（内资）&世界500强（外资）&中国500强&中国民营企业500强&中国制造业民营企业500强&中国服务业民营企业100强&战略性新兴产业领军企业100强&拟上市辅导备案企业&';
						if (_this.searchtype == 1) {
							qysltagShift = [{
									tagName: "全部",
									tagCode: "0"
								}, {
									tagName: "世界500强(内资)",
									tagCode: "A090108"
								}, {
									tagName: "世界500强(外资)",
									tagCode: "A090117"
								}, {
									tagName: "中国500强",
									tagCode: "A090109"
								}, {
									tagName: "中国民营企业500强",
									tagCode: "A090110"
								}, {
									tagName: "中国制造业民营企业500强",
									tagCode: "A090111"
								}, {
									tagName: '拟上市辅导备案企业',
									tagCode: 'A090118'
								}, {
									tagName: "央企",
									tagCode: "A020131"
								},
								{
									tagName: "国有企业",
									tagCode: "A020104"
								}, {
									tagName: "中国服务业民营企业100强",
									tagCode: "A090112"
								}, {
									tagName: "战略性新兴产业领军企业100强",
									tagCode: "A090116"
								},
							];
						} else if (_this.searchtype == 9) {
							comdelateText2 = comdelateText2 + '&终止上市辅导企业&';
							qysltagShift = [{
									tagName: "全部",
									tagCode: "0"
								}, {
									tagName: "世界500强(内资)",
									tagCode: "A090108"
								}, {
									tagName: "世界500强(外资)",
									tagCode: "A090117"
								}, {
									tagName: "中国500强",
									tagCode: "A090109"
								}, {
									tagName: "中国民营企业500强",
									tagCode: "A090110"
								}, {
									tagName: "中国制造业民营企业500强",
									tagCode: "A090111"
								}, {
									tagName: "央企",
									tagCode: "A020131"
								},
								{
									tagName: "国有企业",
									tagCode: "A020104"
								}, {
									tagName: "中国服务业民营企业100强",
									tagCode: "A090112"
								}, {
									tagName: "战略性新兴产业领军企业100强",
									tagCode: "A090116"
								},
							];
						}else if (_this.searchtype == 'A090206' || _this.searchtype == 'A090208') {
							qysltagShift = totalqysl();
							console.log('港美股',qysltagShift);
						
						}




					} else if (type == 10009) { //优质企业专属标签 
						//通用标签删除
						comdelateText = '&企业类型标签&企业规模标签&行业概念标签&其他个性化标签&技术实力标签&行业潜力标签&区域特色标签&';
						//特有画像标签
						uniqueHuaxiangdata = tagdsta.filter(item => {
							return item.tagName != '企业实力标签' && item.tagName != '行业潜力标签';
						});
						//特有企业实力

						// comdelateText2='&专精特新企业&省级专精特新企业&省级专精特新小巨人企业&猎豹企业&牛羚企业&创新型企业&世界500强（外资）&'; old 新三板上市公司 
						comdelateText2 = '&专精特新中小企业&省级专精特新企业&省级专精特新小巨人企业&创新型企业&世界500强（外资）&新三板挂牌公司&拟上市辅导备案企业';
						qysltagShift = [{
							tagName: "全部",
							tagCode: "0"
						}, {
							tagName: "专精特新小巨人",
							tagCode: "A090103"
						}, {
							tagName: "专精特新中小企业",
							tagCode: "A080101"
						}, {
							tagName: "新三板挂牌公司",
							tagCode: "A080116"
						}, ];
						// console.log('优质企业企业实力标签',tagdsta);
					}
					//每个企业库有不同的通用画像标签 筛选后删了再存
					for (var i = 0; i < _this.tyinitialTagdata.length; i++) {
						var comtagname = _this.tyinitialTagdata[i].tagName + '&';
						// console.log(comtagname,comdelateText.indexOf(comtagname)<1)
						if (comdelateText.indexOf(comtagname) < 1) {
							conHuaXiangTag.push(_this.tyinitialTagdata[i]);
						}
					}
					// console.log('通用画像标签储存1',_this.tyinitialTagdata)

					_this.initialTagdata = conHuaXiangTag.concat(uniqueHuaxiangdata);

					_this.initialTagdata = _this.initialTagdata.filter(list => {
						return _this.hxtagname.indexOf(list.tagName) > 0;
					})
					// console.log('查看格式',_this.initialTagdata,_this.hxtagname);
					// console.log('bbb',_this.tyinitialTagdata,conHuaXiangTag,uniqueHuaxiangdata);
					// console.log('aaa',_this.hxtagname,_this.initialTagdata);

					for (var i = 0; i < _this.initialTagdata.length; i++) {
						searchdataempty.push('empty');
					}
					qysltagUniqueData = tagdsta[0].children.filter(item => {
						return comdelateText2.indexOf(item.tagName) < 1;
					});
					_this.qysltagUnique = qysltagShift.concat(qysltagUniqueData);
					_this.searchtagdata = searchdataempty;
					_this.ajaxsearchcompany();
					// console.log(tagdsta,_this.searchtagdata);
				});
			},
			//选择标签
			choosetaglist(obj, index) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.searchtagdata[index + 1] = obj.target.value;
				// console.log(this.searchtagdata);
				this.ajaxsearchcompany();
			},
			choosetaglist1(obj, index) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.comSearchdata[index] = obj.target.value;
				// console.log(this.comSearchdata);
				this.ajaxsearchcompany();
			},
			pageHandler: function(page) {
				this.ajaxsearchcompany(page, 'search');
			},
			//省份城市选择 
			cityScreenFun(pid,cid,cuid){ 
				this.cityid = cid;
				this.countyid = cuid; 
				this.provinceid = pid;
				this.ajaxsearchcompany();
			},
			// provincechoose(id, i) {
			// 	this.provinceid = id;
			// 	this.cityid = 0;
			// 	this.countyid = 0;
			// 	this.countydata = [];
			// 	if (i != "all" && this.provincedata[i].children != null) {
			// 		this.citydata = this.provincedata[i].children;
			// 	} else {
			// 		this.citydata = [];
			// 	}
			// 	this.page = 1;
			// 	this.ajaxsearchcompany();
			// },
			// choosecity(id, i) {
			// 	//	console.log('choosecity',id);
			// 	this.cityid = id;
			// 	this.countyid = 0;
			// 	if (i != "all" && this.citydata[i].children != null) {
			// 		this.countydata = this.citydata[i].children;
			// 	} else {
			// 		this.countydata = [];
			// 	}
			// 	this.page = 1;
			// 	this.ajaxsearchcompany();
			// },
			// choosecounty(id) {
			// 	//	console.log('choosecity',id);
			// 	this.countyid = id;
			// 	this.page = 1;
			// 	this.ajaxsearchcompany();
			// },
			//加入、移除目标企业
			collectToggle(list) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				var _this = this,
					cid = list.collectId;
				var ajaxurl = "",
					ajaxdata = {};
				if (cid == 0) {
					ajaxurl = this.$api.cyl.collect.add();
					ajaxdata = {
						type: list.collectType,
						id: list.stockCode
					}
				} else {
					ajaxurl = this.$api.cyl.collect.remove();
					ajaxdata = {
						collectId: list.collectId
					};
				}
				$.ajax({
					type: "POST",
					url: ajaxurl,
					data: ajaxdata,
					headers: {
						AuthToken: this.userdata.token
					},
					success: function(res) {
						// console.log('1123',res);
						if (res.success) {
							if (cid == 0) {
								list.collectId = res.data.collectId;
							} else {
								list.collectId = 0;
							}
						}
					}
				})
			},
			ajaxsearchcompany(pages, searchtype) {
				this.bus.$emit('loading', true);
				this.page = pages ? pages : 1;
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.list(), searchtype) + '&page=' + this.page;
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(ajaxurl);
					if (res.data.success) {
						var dataenterlist = res.data.list;
						_this.exportnum = res.data.extend.exportRemainder;
						_this.allowexport = res.data.extend.allowExport;
						// if (_this.searchtype == 1 || _this.searchtype == 2) {
						// 	//大小企业 
						// } else if (_this.searchtype == 5) {
						// 	//机构列表 
						// }
						for (var i = 0; i < res.data.list.length; i++) {
							var ddd = dataenterlist[i].financingRound;

							dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[
								i].notionCode, 'notionsort');
							dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i]
								.tagCode);
							//创新企业专属
							if (dataenterlist[i].financingRound != null && dataenterlist[i].financingRound.length >
								0) {
								dataenterlist[i].financingRound = ddd;
							} else {
								dataenterlist[i].financingRound = [{
									amount: "-",
									id: 'none',
									org: "-",
									orgList: '-',
									rount: "-",
									time: "-"
								}];
							}
						}
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize;
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext;
						_this.exportbtn = true;
						_this.confirmtext = "确认导出";
						_this.enterpristlist = dataenterlist;
						_this.bus.$emit('loading', false);
					} else {

					}
				}).catch(function(error) {});
				// console.log(datas);  
			},
			//  
		}
	}
</script>

<style>
</style>